export const COLLAPSIBLE_CONTENT = 'CollapsibleContent';
export const COLLAPSIBLE_SECTION = 'CollapsibleSection';
